// extracted by mini-css-extract-plugin
module.exports = {"button":"AnswerBox_button__3Y-TH","full-width-avatar":"AnswerBox_full-width-avatar__17eDE","inputField":"AnswerBox_inputField__3d9n1"};